export default
  [
    {
      "name": "Reverse Text",
      "component": "reverse-text",
      "link": "/reverse-text"
    },
    {
      "name": "Word Counter",
      "component": "word-counter",
      "link": "/word-counter"
    },
    {
      "name": "Create Palindrome String",
      "component": "create-palindrome-string",
      "link": "/create-palindrome-string"
    },
    {
      "name": "Upside Down Text",
      "component": "upside-down-text",
      "link": "/upside-down-text"
    },
    {
      "name": "Case Converter",
      "component": "case-converter",
      "link": "/case-converter"
    },
    {
      "name": "Remove Duplicate Lines",
      "component": "remove-duplicate-lines",
      "link": "/remove-duplicate-lines"
    },
    {
      "name": "Sort Lines",
      "component": "sort-lines",
      "link": "/sort-lines"
    },
    {
      "name": "Calculate String Length",
      "component": "calculate-string-length",
      "link": "/calculate-string-length"
    },
    {
      "name": "Occurrence Counter",
      "component": "occurrence-counter",
      "link": "/occurrence-counter"
    },
    {
      "name": "Find And Replace Text",
      "component": "find-and-replace-text",
      "link": "/find-and-replace-text"
    },
    {
      "name": "Add Prefix/Suffix To Lines",
      "component": "add-prefix-suffix-to-lines",
      "link": "/add-prefix-suffix-to-lines"
    },
    {
      "name": "Random Line Picker",
      "component": "random-line-picker",
      "link": "/random-line-picker"
    },
    {
      "name": "Strip HTML Tags",
      "component": "strip-html-tags",
      "link": "/strip-html-tags"
    },
    {
      "name": "Binary Text Converter",
      "component": "binary-text-converter",
      "link": "/binary-text-converter"
    },
    {
      "name": "Hex Text Converter",
      "component": "hex-text-converter",
      "link": "/hex-text-converter"
    },
    {
      "name": "Random String Generator",
      "component": "random-string-generator",
      "link": "/random-string-generator"
    },
    {
      "name": "Remove Accents",
      "component": "remove-accents",
      "link": "/remove-accents"
    },
    {
      "name": "Remove Empty Lines",
      "component": "remove-empty-lines",
      "link": "/remove-empty-lines"
    },
    {
      "name": "Remove Line Breaks",
      "component": "remove-line-breaks",
      "link": "/remove-line-breaks"
    },
    {
      "name": "Remove Extra Spaces",
      "component": "remove-extra-spaces",
      "link": "/remove-extra-spaces"
    },
    {
      "name": "Remove Lines Containing",
      "component": "remove-lines-containing",
      "link": "/remove-lines-containing"
    },
    {
      "name": "Base64 Encode & Decode",
      "component": "base-64-encode-decode",
      "link": "/base-64-encode-decode"
    },
    {
      "name": "URL Encode & Decode",
      "component": "url-encode-decode",
      "link": "/url-encode-decode"
    },
    {
      "name": "Escape & Unscape HTML",
      "component": "escape-unscape-html",
      "link": "/escape-unscape-html"
    }
  ]